import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import axios from "axios";
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import { SERVER_ADDRESS } from '../../settings';
import { themeConfig } from "../../settings";
import appActions from "../../redux/app/actions";
import config from "../../redux/languageSwitcher/config";
import languageActions from "../../redux/languageSwitcher/actions";
import themes from "../../settings/themes";
import TopbarNotification from "./topbarNotification";
import TopbarUser from "./topbarUser";
import TopbarWrapper from "./topbar.style";
import { getToken } from '../../helpers/utility';
import IntlMessages from "../../components/utility/intlMessages";

var TOKEN = "";

const { Header } = Layout;
const { toggleCollapsed } = appActions;
const { changeLanguage } = languageActions;
const customizedTheme = themes[themeConfig.theme];

class Topbar extends Component {
   constructor(props) {
      super(props);

      this.state = {
         langCodes: [],
         selectedLang: null,
         isGlobalSearchActive: false,
         flagCode: "BR",
         isLoading: false,
         selectedContext: [],
         searchPermissionsLoaded: false,
         hideNotifications: false,
      };
   }

   render() {
      const { toggleCollapsed, changeLanguage, language } = this.props;
      const collapsed = this.props.collapsed && !this.props.openDrawer;
      const styling = {
         background: customizedTheme.backgroundColor,
         position: "fixed",
         width: "100%",
         height: 60
      };

      const rightIcons = {
         marginBottom: 0,
      };

      return (
         <TopbarWrapper>
            <Header
               style={styling}
               className={collapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"}
            >
               <div className="isoLeft" style={{ display: 'flex', alignItems: 'center' }} >
                  <button
                     className={collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"}
                     style={{ color: "#FFF" }}
                     onClick={toggleCollapsed}
                  />
                  <h1 style={{ color: 'whitesmoke', fontSize: '1.2rem', margin: 0, marginLeft: '1rem' }}><IntlMessages id="customerHub" /></h1>
               </div>
               <ul className="isoRight" style={rightIcons}>
                  {
                     this.state.hideNotifications === false ?
                        <li
                           onClick={() => this.setState({ selectedItem: "notification" })}
                           className="isoNotify"
                        >
                           <TopbarNotification />
                        </li> : null
                  }
                  <li
                     className="isoLang"
                  >
                     <div hidden={this.state.isLoading}>
                        <ReactFlagsSelect
                           onSelect={(countryCode) => {
                              const option = config.options.find(x => countryCode === x.code);
                              const aux = option.languageId || 'english'

                              this.setState({ selectedLang: countryCode }, () => {
                                 this.PostLanguageChange(countryCode);
                                 changeLanguage(aux);
                                 window.location.reload(true);
                              });
                           }}
                           ref="userFlag"
                           fontSize={'32px'}
                           countries={this.state.langCodes}
                           defaultCountry={this.state.flagCode}
                           showSelectedLabel={false}
                           showOptionLabel={false} />
                     </div>
                  </li>
                  <li
                     onClick={() => this.setState({ selectedItem: "user" })}
                     className="isoUser"
                  >
                     <TopbarUser locale={language.locale} />
                  </li>
               </ul>
            </Header>
         </TopbarWrapper>
      );
   }

   componentWillReceiveProps(nextProps) {
      this.refs.userFlag.updateSelected(nextProps.language.code);
      this.setState({
         flagCode: nextProps.language.code
      });
      this.setState({ isLoading: false });
   }

   PostLanguageChange(code) {
      axios.post(`${SERVER_ADDRESS}/api/Account/SetUserLanguage?LanguageCode=${code}`, null, {
         headers: {
            Authorization: `Bearer ${TOKEN}`
         }
      })
   }

   componentDidMount() {
      TOKEN = getToken();
      this.setState({ isLoading: true });
      this.mountLangArray();
      this.getGlobalSearchState();
      this.getUserPermissionsForSearch();
      this.ShowsNotifications();
   }

   getUserPermissionsForSearch = () => {
      axios.get(`${SERVER_ADDRESS}/api/GlobalSearch/getUserPermissionsSearch`, {
         headers: {
            Authorization: `Bearer ${TOKEN}`
         }
      }).then(x => {
         this.setState({ selectedContext: x.data, searchPermissionsLoaded: true });
      });
   }

   ShowsNotifications = () => {
      axios.get(`${SERVER_ADDRESS}/api/Common/ShowsNotifications`, {
         headers: {
            Authorization: `Bearer ${TOKEN}`
         }
      }).then(x => {
         this.setState({
            hideNotifications: x.data
         });
      });
   }

   mountLangArray() {
      var configOptions = config.options;
      const langCodesMap = configOptions.filter(x => x.code === 'BR').map(x => x.code);
      this.setState({ langCodes: langCodesMap, });
   }

   changeLang = (countryCode) => {
      const codeId = config.options.find(x => countryCode === x.code);
      changeLanguage(codeId);
      this.setState({ selectedLang: countryCode });
   }

   getGlobalSearchState = () => {
      axios
         .get(`${SERVER_ADDRESS}/api/Backoffice/Settings/GlobalSearchActive`, {
            headers: {
               Authorization: `Bearer ${TOKEN}`
            }
         })
         .then(data => {
            this.setState({ isGlobalSearchActive: data.data });
         })
   }
}

export default connect(
   state => ({
      ...state.App,
      ...state.LanguageProvider,
   }),
   { toggleCollapsed, changeLanguage }
)(Topbar);
